/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
// noinspection ES6CheckImport
import {Pagination, Table} from 'antd';
import CurrencyFormat from 'react-currency-format';
import Button from '@material-ui/core/Button';
import {useDispatch, useSelector} from 'react-redux';

import 'antd/dist/antd.css';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { addToShoppingCart } from '../../redux/actions/shoppingCart';
import { Box } from '@material-ui/core';
import { ShoppingBasket } from '@material-ui/icons';
import { SELECTOR_FAVORITE_PRODUCTS, SELECTOR_FAVORITE_PRODUCTS_TOTALS } from '../../redux/selectors/products';
import { getFavoriteProducts } from '../../redux/actions/products';
import { getPicture } from '../../modules/imageHandler';

function FavoritesTable() {
  const favorites = useSelector(SELECTOR_FAVORITE_PRODUCTS);
  const pagination = useSelector(SELECTOR_FAVORITE_PRODUCTS_TOTALS);

  const isMobil = useMediaQuery('(max-width:510px)');
  const dispatch = useDispatch();

  const columns = isMobil
    ? [
        {
          render: ({ favorite: record }) => {
            return (
              <div>
                <div>
                  Nombre: <span>{record.name}</span>
                </div>
                <div>
                  Precio:
                  <CurrencyFormat
                    value={record.discount_price_whit_tax || record.price_with_tax}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    renderText={(value) => <span>{value}</span>}
                  />
                </div>
                <div>
                  Cantidad disponible:
                  <span>{record.quantity}</span>
                </div>
                <Box display="flex" gridGap={10}>
                    <Button
                      variant="outlined"
                      size="small"
                      color="secondary"
                      onClick={() => {
                        dispatch(addToShoppingCart({ productId: record.id, quantity: 1 }))
                      }}
                    >
                      <ShoppingBasket />
                    </Button>
                </Box>
              </div>
            );
          },
        },
      ]
    : [
        {
          dataIndex: ['favorite', 'main_image'],
          render: (path) => <img src={getPicture(path, 100, 100)} alt="img" />
        },
        {
          title: 'Nombre',
          dataIndex: ['favorite', 'name'],
          sorter: false,
        },
        {
          title: 'Precio',
          render: ({favorite: record}) => (
            <CurrencyFormat
              value={record.discount_price_whit_tax || record.price_with_tax}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              renderText={(value) => <span>{value}</span>}
            />
          ),
        },
        {
          title: 'Cantidad disponible',
          dataIndex: ['favorite','quantity']
        },
        {
          title: '',
          // dataIndex: 'id',
          render: ({favorite: record}) => (
            <Box display="flex" gridGap={10}>
                <Button
                  variant="outlined"
                  size="small"
                  color="secondary"
                  onClick={() => {
                    dispatch(addToShoppingCart({ productId: record.id, quantity: 1 }))
                  }}
                >
                  <ShoppingBasket />
                </Button>
            </Box>
          ),
        },
      ];

  useEffect(() => {
    getFavoritesData(0);
  }, []);

  function getFavoritesData(skip) {
    dispatch(getFavoriteProducts({query: {$skip: skip}}));
  }

  return (
    <div>
      <Table
        columns={columns}
        rowKey={(item) => item.id}
        dataSource={favorites.reverse()}
        pagination={false}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingTop: 15,
        }}
      >
        <Pagination
          total={pagination.total}
          showSizeChanger={false}
          defaultPageSize={10}
          defaultCurrent={1}
          onChange={(current, pageSize) => {
            getFavoritesData((current - 1) * pageSize);
          }}
        />
      </div>
    </div>
  );
}

export default FavoritesTable;
